export class ImagePopUp{
	init(){
    $('.picture').each(function() {
      if($(this).hasClass('picture--video')){
        $(this).find('a').magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        })
      }else{
    		$(this).find('a').magnificPopup({
          type: 'image',
          closeOnContentClick: true,
          closeBtnInside: false,
          fixedContentPos: true,
          mainClass: 'mfp-no-margins mfp-with-zoom',
          image: {
            verticalFit: true
          },
          zoom: {
            enabled: true,
            duration: 300
          }
        });        
      }
    })
    
	}
}